import React from 'react';
import styles from './ContactProfile.module.scss';
import Header from 'component/layout/header/Header';
import Container from 'component/atom/container/Container';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useParams } from 'react-router-dom';
import { useFetch } from 'hooks/useFetch';
import { formsEndpoints } from 'hooks/endpoints';
import ChatConsoleView from 'component/organism/chat-console/ChatConsoleView';
export const FilledStar = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M19.9677 7.58739C19.8933 7.36518 19.7008 7.20329 19.4692 7.16766L13.3208 6.22818L10.566 0.359414C10.4629 0.140015 10.2422 0 10 0C9.75784 0 9.53751 0.140015 9.43407 0.359414L6.67926 6.22818L0.530842 7.16797C0.299269 7.20329 0.107073 7.36549 0.0323815 7.5877C-0.041997 7.8096 0.0139432 8.05463 0.177701 8.22246L4.64478 12.8033L3.58911 19.274C3.55036 19.5103 3.65005 19.7481 3.846 19.8856C3.9535 19.9616 4.07945 20 4.2057 20C4.30946 20 4.41384 19.9737 4.50822 19.9219L9.99972 16.8843L15.4912 19.9219C15.5856 19.9737 15.69 20 15.7937 20C15.92 20 16.0463 19.9616 16.1534 19.8856C16.3494 19.7481 16.4491 19.5103 16.4103 19.274L15.3547 12.8033L19.8217 8.22246C19.9858 8.05432 20.0421 7.80929 19.9677 7.58739Z'
      fill='#F6B402'
    />
  </svg>
);

export const EmptyStar = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M19.9677 7.58739C19.8933 7.36518 19.7008 7.20329 19.4692 7.16766L13.3208 6.22818L10.566 0.359414C10.4629 0.140015 10.2422 0 10 0C9.75784 0 9.53751 0.140015 9.43407 0.359414L6.67926 6.22818L0.530842 7.16797C0.299269 7.20329 0.107073 7.36549 0.0323815 7.5877C-0.041997 7.8096 0.0139432 8.05463 0.177701 8.22246L4.64478 12.8033L3.58911 19.274C3.55036 19.5103 3.65005 19.7481 3.846 19.8856C3.9535 19.9616 4.07945 20 4.2057 20C4.30946 20 4.41384 19.9737 4.50822 19.9219L9.99972 16.8843L15.4912 19.9219C15.5856 19.9737 15.69 20 15.7937 20C15.92 20 16.0463 19.9616 16.1534 19.8856C16.3494 19.7481 16.4491 19.5103 16.4103 19.274L15.3547 12.8033L19.8217 8.22246C19.9858 8.05432 20.0421 7.80929 19.9677 7.58739Z'
      fill='#8A8A8A'
    />
  </svg>
);
const totalStars = 5;

const ContactProfile = () => {
  const { chatId, formId } = useParams();
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;

  const { data: chatProfile } = useFetch(
    ['chatProfile', formId, chatId],
    formsEndpoints?.getChatProfile(),
    {
      enabled: true,
    },
    {
      FormId: formId,
      ChatId: chatId,
    }
  );

  const rating = chatProfile?.data?.chat?.chats?.[0]?.rating ?? 0;

  return (
    <div className={styles['contact-profile']}>
      <Header title='contact profile' isBack />
      <div className={styles['layout-container']}>
        <div className={styles['profile-layout']}>
          <Container className={styles.information}>
            <div className={styles['application-card']}>
              <div className={styles['full-name-section']}>
                <p className={styles['full-name']}>
                  {chatProfile?.data?.formEntries?.[0]?.formDetails?.find(
                    (d) =>
                      (d?.fieldLabel ?? '').trim().toLowerCase() === 'full name'
                  )?.value ?? ''}
                </p>
                <p className={styles['category-text']}>
                  {chatProfile?.data?.chat?.chatCategory?.categoryText}
                </p>
              </div>
              <div className={styles['info-section']}>
                {chatProfile?.data?.formEntries[0]?.formDetails.map(
                  (item, index) => {
                    const value = item?.value ?? '-';
                    const isString = typeof value === 'string';
                    const isHttpUrl = isString && /^https?:\/\//i.test(value);
                    const isDataUrl =
                      isString && /^data:[^;]+;base64,/i.test(value);
                    const isRawBase64 =
                      isString &&
                      !isHttpUrl &&
                      value.length > 180 &&
                      /^[A-Za-z0-9+/=\s]+$/.test(value);

                    return (
                      <div className={styles['info-block']} key={index}>
                        <div className={styles.label}>
                          {item?.fieldLabel ?? '-'}
                        </div>
                        <div className={styles.value}>
                          <p
                            // href={value}
                            // target='_blank'
                            // rel='noopener noreferrer'
                            className={styles.link}
                          >
                            {value}
                          </p>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </Container>
          <Container className={styles.summary}>
            <div className={styles['card']}>
              <div className={styles.summaryName}>Lead Summary</div>
              <div className={styles['lead-section']}>
                <div className={styles['summary-lead']}>
                  {chatProfile?.data?.chat?.chats[0]?.conversationContext}
                </div>
              </div>
            </div>
            <div className={styles['confidence-score']}>
              <div className={styles['score-container']}>
                <div className={styles['svg-container']}>
                  <SvgWithBranding
                    type='conversation-dots'
                    color={page_TextColor}
                  />
                  <p className={styles['text']}>Intent to Apply Score</p>
                </div>
                <div className={styles['rating-container']}>
                  <p className={styles['rating-text']}>AI Analysis</p>
                  <div className={styles['rating']}>
                    {[...Array(totalStars)].map((_, index) =>
                      index < rating ? (
                        <FilledStar key={index} />
                      ) : (
                        <EmptyStar key={index} />
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Container className={styles.conversation}>
          {chatProfile?.data?.chat?.chats[0]?.chatId && (
            <ChatConsoleView
              externalConversationId={chatProfile?.data?.chat?.chats[0]?.chatId}
              disableConsole
              hasHeader={false}
              className={styles.conversationStyle}
              bodyClassName={styles.bodyClassName}
              ChatSource={2}
            />
          )}
        </Container>
      </div>
    </div>
  );
};

export default ContactProfile;
